export default __webpack_public_path__ + "static/media/TF_21.47721b14.png";